import React from 'react';
import PropTypes from 'prop-types';
import theme from 'utils/theme';
import AlertBase from './AlertBase';

const STATE_ICONS = {
  error: 'interface-alert-circle-icon.svg',
  warning: 'interface-alert-triangle-icon.svg',
  success: 'check-circle-2-icon.svg',
  info: 'interface-information-icon.svg',
};

const STATE_COLORS = {
  error: theme.colors.error,
  warning: theme.colors.warning,
  success: theme.colors.success,
  info: theme.colors.info,
};

const Alert = props => {
  const { className, children, state } = props;

  const icon = STATE_ICONS[state];
  const color = STATE_COLORS[state];

  return (
    <AlertBase className={className} icon={icon} color={color}>
      {children}
    </AlertBase>
  );
};

Alert.propTypes = {
  children: PropTypes.any.isRequired,
  state: PropTypes.oneOf(Object.keys(STATE_ICONS)),
};

export default Alert;
